import React, { FCWithChildren, useEffect, useRef, useState } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { CatalogProduct } from '@interfaces/models/catalogProduct';

interface ImpressionTrackingWrapperProps {
  onVisible: (index: number, productsOnRow: CatalogProduct[]) => void;
  impressionTrackingIndex: number;
  productsOnRow: CatalogProduct[];
  className?: string;
}

const ImpressionsTrackingWrapper: FCWithChildren<ImpressionTrackingWrapperProps> = ({
  children,
  onVisible,
  impressionTrackingIndex,
  productsOnRow,
  className,
}) => {
  const intersectionRef = React.useRef(null);
  const entry = useIntersectionObserver(intersectionRef, {
    freezeOnceVisible: false,
    threshold: 1,
  });
  const isIntersecting = !!entry?.isIntersecting;
  const viewCountRef = useRef(0);
  const [doTrackImpressions, setDoTrackImpressions] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDoTrackImpressions(true); // we wait 1s before starting to track impressions to ensure programmatic scrolling as finished
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (isIntersecting && viewCountRef.current === 0 && doTrackImpressions) {
      viewCountRef.current++;
      onVisible(impressionTrackingIndex, productsOnRow);
    }
    // only trigger onVisible when product's visibility changes
  }, [isIntersecting, doTrackImpressions]);

  return (
    <li
      ref={intersectionRef}
      className={className}
    >
      {children}
    </li>
  );
};

export default ImpressionsTrackingWrapper;
